module.exports = __webpack_public_path__ + "static/media/chile.deec204d.svg";